<template>
  <!--
    ********************************************************
    ****   FORMATO NUMERO 7 PAGINA EMBEBIDA EN SECCION  ****
    ****                                                ****
    ********************************************************
  -->
     <div class="row"> 
         <div id="Formato7" class="col-12">   
          <embed v-for="(contenido,index) in contenidos" :key="index" :class="columnasContenido(contenido.TamanoDeLaColumna)" v-bind:src="contenido.RutaDeArchivo"/>
         </div>
    </div>

</template>

<script>
export default {
    props:{

        contenidos:Array
    },
    methods:{
        columnasContenido(columnas){
            var respuesta = 'col-'+columnas
            return respuesta;
        }
    }

}
</script>
<style scoped>

  #Formato7 embed {
    width: 100%;
    height: calc(100vh - 26vh);
  }
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/ContenidoEmbebido.vue